// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2DLjB","label":"Radio_label__vedfG","checkMark":"Radio_checkMark__2z2ON","disabled":"Radio_disabled__1qnD3"};